import React from 'react';

import WingcoreTopView from '../../../main/assets/images/wingcore/wingcore-top-view.webp';

export const FirstSpecs = () => {
  return (
    <section className="wingcore-firstspecs-section">
      <div className="wingcore-firstspecs-content">
        <div className="wingcore-firstspecs-container">
          <div className="wingcore-firstspecs-text">
            <h2 className="wingcore-firstspecs-title">weight</h2>
            <p className="wingcore-firstspecs-subtitle">36.6 G</p>
          </div>
          <div className="wingcore-firstspecs-text">
            <h2 className="wingcore-firstspecs-title">dimensions</h2>
            <p className="wingcore-firstspecs-subtitle">54 x 39 x 17 mm</p>
          </div>
          <div className="wingcore-firstspecs-text">
            <h2 className="wingcore-firstspecs-title">Mounting</h2>
            <p className="wingcore-firstspecs-subtitle">30.5 x 30.5 mm</p>
          </div>
          <div className="wingcore-firstspecs-text">
            <h2 className="wingcore-firstspecs-title">BEC</h2>
            <p className="wingcore-firstspecs-subtitle">5V/8A, 6/7.2V/10A</p>
          </div>
        </div>
        <div className="wingcore-firstspecs-container">
          <div className="wingcore-firstspecs-text">
            <h2 className="wingcore-firstspecs-title">Power Supply</h2>
            <p className="wingcore-firstspecs-subtitle">
              11.1VDC - 44.4VDC (3 - 12s LiIon)
            </p>
          </div>
          <div className="wingcore-firstspecs-text">
            <h2 className="wingcore-firstspecs-title">Buzzer</h2>
            <p className="wingcore-firstspecs-subtitle">On-Board Integrated</p>
          </div>
          <div className="wingcore-firstspecs-text">
            <h2 className="wingcore-firstspecs-title">Current Sensor</h2>
            <p className="wingcore-firstspecs-subtitle">160A On-Board</p>
          </div>
          <div className="wingcore-firstspecs-text">
            <h2 className="wingcore-firstspecs-title">Motor Outputs</h2>
            <p className="wingcore-firstspecs-subtitle">
              4x (PWM, Dshot, CAN bus)
            </p>
          </div>
        </div>
      </div>
      <img
        src={WingcoreTopView}
        alt="Top view of the device"
        className="wingcore-firstspecs-product"
      />
    </section>
  );
};
